export enum FloorPlanTabs {
  tables = 'tables',
  sections = 'sections',
}
